import { FC, memo } from 'react';
import Info from './Info';

interface iLabelProps {
  label: string;
  description?: string;
  required?: boolean;
  info?: string;
}

const Label: FC<iLabelProps> = memo(({ children, label, description, required, info }) => {
  return (
    <div className='label-wrapper'>
      <label>
        {label}
        {required && <span>*</span>}
        {info && (
          <div className='info-wrapper'>
            <Info />
            <div className='popup'>
              {info || 'Qui est ut occaecat minim anim duis nostrud ad exercitation ad duis.'}
            </div>
          </div>
        )}
      </label>
      {description && <span className='description'>{description}</span>}
      <div className='content'>{children}</div>
    </div>
  );
});

export default Label;
